import React, { useContext, useEffect } from 'react'
import styles from './ModalFourthView.module.scss'
import ChangeModal from './changeModal'
import { InvoiceModalValues } from './ModalFirstView'
import { API } from 'javascripts/api'
import loading from '../../../../../assets/images/invoice/loading.svg'

const ModalFourthView: React.FC<ChangeModal> = (props) => {
  const context = useContext(InvoiceModalValues)

  useEffect(() => {
    API.createInvoiceNumber({
      registrated_number: 'T' + context.invoiceNumber
    }).then(response => {
      if (response.status === 200) {
        props.changeModal('fifthModal')
      } else {
        context.setErrors(['api_error'])
        props.changeModal('secondModal')
      }
    }).catch(error => {
      context.setErrors([errorValue(error)])
      props.changeModal('secondModal')
    })
  }, [])

  const errorValue = (error) => {
    if (error.response) {
      const status = error.response.status
      if (status === 400) {
        return 'not_found'
      }
    }
    return 'api_error'
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modalContainer}>
        <img src={loading} className={styles.loadingIcon} />
        <div className={styles.sectionText}>
          <p>ただいま登録内容の<br className={styles.hiddenSmUp}/>確認を行なっています。</p>
          <p>そのままの状態で<br className={styles.hiddenSmUp}/>お待ちください。</p>
        </div>
      </div>
    </div>
  )
}
export default ModalFourthView
